// 繁体中文

import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import appBackstage from './app_backstage/app_backstage_zh-TW' // 后台文件（除 自定义应用模块）
import Navigation from './Navigation/Navigation_zh-TW' // 首页
import login from './login/login_zh-TW' // 登录注册
import chat from './chat/chat_zh-TW' // im
import approval from './approval/approval_zh-TW' // 前台审批
import attendance from './attendance/attendance_zh-TW' // 考勤
import customBackstage from './custom_backstage/custom_backstage_zh-TW' // 自定义后台
import customReception from './custom_reception/custom_reception_zh-TW' // 自定义前台
import dataAnalysis from './data_analysis/data_analysis_zh-TW' // 数据分析
import email from './email/email_zh-TW' // 邮件
import knowledge from './knowledge/knowledge_zh-TW' // 知识库
import library from './library/library_zh-TW' // 文件库
import memo from './memo/memo_zh-TW' // 备忘录
import projectTask from './project_task/project_task_zh-TW' // 项目任务
import baseCommon from './base_common/base_common_zh-TW' // 基础通用的（包括用户、公司、登录等信息）
import workbench from './workbench/workbench_zh-TW' // 工作台
import globalSettings from './global_settings/global_settings_zh-TW' // 工作台
import utils from './utils/utils_zh-TW' // 工具类 如：constant、tool等
import salary from './salary/salary_zh-TW' // 工具类 如：constant、tool等
import okr from './okr/okr_zh-TW' // okr
import businessFlow from './business_flow/businessFlow_zh-TW' // 业务流程
import personnelMatrix from './personnelMatrix/PersonnelMatrix_zh-TW' // 人员矩阵
export default {
  ...twLocale,
  ...appBackstage,
  ...Navigation,
  ...login,
  ...chat,
  ...approval,
  ...attendance,
  ...customBackstage,
  ...customReception,
  ...dataAnalysis,
  ...email,
  ...knowledge,
  ...library,
  ...memo,
  ...projectTask,
  ...baseCommon,
  ...workbench,
  ...globalSettings,
  ...utils,
  ...salary,
  ...okr,
  ...businessFlow,
  ...personnelMatrix
}
